export const BENNETT_KEYBOARD = 'bennettKeyboard'
export const FLAPPER = 'flapper'
export const BENNETT_DEFIANT = 'bennettDefiant'
export const BENNETT_RECORDING = 'bennettRecording'
